$(function() {
    $('.buy-gift-card').submit(function (ev) {
        ev.preventDefault();

        var form = $(this);

        var amountField = $(this).find('input[name=amount]');
        var amount = parseFloat(amountField.val());
        var min = parseFloat($(this).attr('min'));
        var max = parseFloat($(this).attr('max'));

        if (amount < min) {
            return alert("Minimum amount is $" + min);
        } else if (amount > max) {
            return alert("Maximum amount is $" + max);
        }

        var failed = false;
        var required = ['first_name', 'last_name', 'address', 'city', 'state', 'zip'];

        $.each(required, function (key, val) {
            var val = form.find('[name=shipping_' + val + ']').val();
            if (!val || val.length < 1) {
                failed = true;
            }
        });

        if (failed) {
            return alert("Please fill in all shipping recipient fields.");
        }

        var handler = StripeCheckout.configure({
            key: STRIPE_KEY,
            image: '/public/img/plums-logo.png',
            locale: 'auto',
            billingAddress: true,
            allowRememberMe: false,
            zipCode: true,
            token: function(token, args) {
                var formData = form.serializeArray();
                formData.push({
                    name: 'action',
                    value: 'buy_gift_card'
                });
                formData.push({
                    name: 'stripe_token',
                    value: token.id
                });
                formData.push({
                    name: 'email',
                    value: token.email
                });
                formData.push({
                    name: 'billing_name',
                    value: args.billing_name
                });

                $.post('/wp-admin/admin-ajax.php', formData).success(function (res) {
                    if (res.response_code) {
                        var receiptAmount = amount * 100;
                        window.location.replace('/thank-you?type=card&amount=' + receiptAmount );
                    } else {
                        alert("We could not process your order. Please try again.");
                    }
                }).error(function (res) {
                    if (res.responseJSON.message) {
                        alert(res.responseJSON.message);
                    }
                });
            }
        });

        handler.open({
            name: "Plum's Cooking",
            description: "Cooking Class Gift Card",
            amount: amount * 100
        });
    });

    $('.pay-basket').find('.input-number').change(function () {
        var form = $(this).parents('form');
        var qty = parseInt($(this).val());
        var subTotal = form.data('price') * qty;
        var shipping = parseInt(form.find('input[name=shipping]').val());
        subTotal += shipping * qty;
        var total = Math.round(subTotal * 1.062);
        form.find('input[name=total]').val(total);

        form.find('.total').find('span').text('$' + parseFloat(total / 100).toFixed(2));
    });

    $('.pay-basket').find('.ship-type').find('button').click(function (ev) {
        ev.preventDefault();

        var form = $(this).parents('form');
        var type = $(this).data('type');
        form.find('input[name=shipping_type]').val(type);

        $('.ship-fields:not(.' + type + ')').fadeOut(200, function () {
            $('.ship-fields.' + type).fadeIn(200);
        });

        var shippingRate = 0;
        if (type == 'shipped') {
            shippingRate = form.data('shipping-rate');
        }
        form.find('input[name=shipping]').val(shippingRate);
        form.find('.input-number').change();

        form.find('.final-pay').fadeIn(200);
    });

    $('.pay-basket').submit(function (ev) {
        ev.preventDefault();

        var form = $(this);

        var basketId = $(this).find('input[name=basket_id]').val();
        var quantity = $(this).find('.input-number').val();
        var total = $(this).find('input[name=total]').val();
        var amount = parseFloat(total);
        var shippingType = $(this).find('input[name=shipping_type]').val();


        if (!shippingType) {
            return alert("Please select wether you wish to pick up in store or ship.");
        }

        if (shippingType == 'shipped') {
            var failed = false;
            var required = ['first_name', 'last_name', 'address', 'city', 'state', 'zip', 'phone'];

            $.each(required, function (key, val) {
                var val = form.find('[name=shipping_' + val + ']').val();
                if (!val || val.length < 1) {
                    failed = true;
                }
            });

            if (failed) {
                return alert("Please fill in all shipping recipient fields.");
            }
        } else {
            var failed = false;
            var required = ['first_name', 'last_name', 'phone'];

            $.each(required, function (key, val) {
                var val = form.find('[name=pick_up_' + val + ']').val();
                if (!val || val.length < 1) {
                    failed = true;
                }
            });

            if (failed) {
                return alert("Please fill in all fields.");
            }
        }

        var description = quantity + ' ' + form.data('singular');
        if (quantity > 1) {
            description = quantity + ' ' + form.data('plural');
        }

        var handler = StripeCheckout.configure({
            key: STRIPE_KEY,
            image: '/public/img/plums-logo.png',
            locale: 'auto',
            billingAddress: true,
            allowRememberMe: false,
            zipCode: true,
            token: function(token, args) {
                var formData = form.serializeArray();
                formData.push({
                    name: 'action',
                    value: 'buy_basket'
                });
                formData.push({
                    name: 'stripe_token',
                    value: token.id
                });
                formData.push({
                    name: 'email',
                    value: token.email
                });
                formData.push({
                    name: 'billing_name',
                    value: args.billing_name
                });

                $.post('/wp-admin/admin-ajax.php', formData).success(function (res) {
                    if (res.response_code) {
                        window.location.replace('/thank-you?id=' + basketId + '&amount=' + amount + '&type=basket&qty=' + quantity);
                    } else {
                        alert("We could not process your order. Please try again.");
                    }
                }).error(function (res) {
                    if (res.responseJSON.message) {
                        alert(res.responseJSON.message);
                    }
                });
            }
        });

        handler.open({
            name: "Plum's Cooking",
            description: description,
            amount: total
        });
    });

    if ($('.basket-list').length > 0) {
        var basketList = $('.basket-list');
        basketList.isotope({
            itemSelector: '.single-basket',
            layoutMode: 'fitRows'
        });

        var categoryFilter = null;
        var priceFilter = null;

        $('.basket-filters').find('a').click(function (ev) {
            ev.preventDefault();

            var li = $(this).parent();
            var ul = $(this).parents('ul');

            if ($(this).data('category')) {
                if (!li.hasClass('active')) {
                    categoryFilter = $(this).data('category');
                    ul.find('.active').removeClass('active');
                    li.addClass('active');
                } else {
                    categoryFilter = null;
                    li.removeClass('active');
                }
            }

            if ($(this).data('price')) {
                if (!li.hasClass('active')) {
                    priceFilter = $(this).data('price');
                    ul.find('.active').removeClass('active');
                    li.addClass('active');
                } else {
                    priceFilter = null;
                    li.removeClass('active');
                }
            }

            if (categoryFilter == 'all') {
                categoryFilter = null;
            }

            if (priceFilter == 'all') {
                priceFilter = null;
            }

            var filter = '';

            if (categoryFilter) {
                filter += 'category-' + categoryFilter;
            } else {
                $('[data-category=all]').parent().addClass('active');
            }

            if (priceFilter) {
                filter += 'price-' + priceFilter;
            } else {
                $('[data-price=all]').parent().addClass('active');
            }

            if (filter) {
                filter = '.' + filter;
            } else {
                filter = '*';
            }

            basketList.isotope({
                filter: filter
            });
        });
    }

    function isotope() {

        var $classGrid = $('.class-listings ul');

        $classGrid.isotope({
            itemSelector: 'li',
            layoutMode: 'fitRows'
        });

        $('.sorting-select-box').on('change', function(){
            var value = $(this).val();
            var clearFiltering = $('.clear-filtering');
            if(value == ""){
                $classGrid.isotope({filter: '*'});
                clearFiltering.addClass('hidden');
            } else {
                $classGrid.isotope({filter: '.' + value});
                clearFiltering.removeClass('hidden');
            }
            $('select.sorting-select-box').not(this).val('');
        });

        $('.clear-filtering').on('click', function() {
            $classGrid.isotope({filter: '*'});
            $(this).addClass('hidden');
            $('select.sorting-select-box').val('');
        });

    }

    function slick() {

        var $slickClasses = $('.class-carousel-slick');

        $slickClasses.slick({
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            nextArrow: '<div class="carousel-next"><img src="/public/img/design/slide-right.png" alt=""></div>',
            prevArrow: '<div class="carousel-prev"><img src="/public/img/design/slide-left.png" alt=""></div>',
            responsive: [
                {
                    breakpoint: 1000,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        });

    }



/**
 * GIFT REGISTRY
 */
    

        $('form#registryPurchase').find('.itemqty').change(function () {
    
            var form = $(this).parents('form');

            var freeShipping = "undecided";
            
            var totalQty = 0;
            var subtotalProducts = 0;
            var subtotalTaxProducts = 0;
            var totalTax = 0;
            var totalPrice = 0;

            var hasProduct = false;
            
            $('select.itemqty').each(function(){
                
                var productQty = 0;
                var productPrice = 0;
                var chargeTax = true;
                
                if( $(this).val() ){
                    
                    productQty = parseInt($(this).val());
                    productPrice = parseFloat( $(this).attr('item-price') ) * productQty;

                    if( $(this).attr('taxable') == 'no' ){
                        chargeTax = false;
                    }

                    if( $(this).attr('freeshipping') == 'yes'){
                        //only set to free shipping if it's still undecided, otherwise set to false
                        if( freeShipping == "undecided" ){
                            freeShipping = true;
                        }
                    } else {
                        freeShipping = false;
                    }
                    
                    hasProduct = true;
                } else {
                    productQty = parseInt(0);
                    productPrice = parseInt(0);
                }

                totalQty = parseInt(totalQty) + productQty;
                subtotalProducts = parseFloat(subtotalProducts) + productPrice;

                if( chargeTax ){
                    subtotalTaxProducts = parseFloat(subtotalTaxProducts) + productPrice;
                }
    
            });

                        
            if( !hasProduct ){
                $('.ship-fields').hide();
                $('.final-pay').hide();
                shippingPrice = '';
                form.find('input[name=shipping_type]').val('');
                form.find('input[name=shipping]').val(0);
                form.find('input[name=product_subtotal]').val(0);
                form.find('input[name=total_tax]').val(0);
                form.find('input[name=total]').val(0);
                form.find('.total').find('span').text('$0.00');
            }
    
    
            var shippingPrice = form.find('input[name=shipping]').val();

            if( freeShipping ){
                form.find('input[name=shipping_free]').val('free-plm-shipping');
                $('#shipToCoupleButton').find('span.ship-price').text('0.00');
                $('#shipSomewhereButton').find('span.ship-price').text('0.00');
                shippingPrice = 0;
            } else {
                form.find('input[name=shipping_free]').val('');
                $('#shipToCoupleButton').find('span.ship-price').text('9.99');
                $('#shipSomewhereButton').find('span.ship-price').text('6.99');

                if( form.find('input[name=shipping_type]').val() == 'shipped' ){
                    shippingPrice = 6.99;
                }
                if( form.find('input[name=shipping_type]').val() == 'ship-to-couple' ){
                    shippingPrice = 9.99;
                }
            }

            totalTax = (( parseFloat(subtotalTaxProducts) + parseFloat(shippingPrice) ) * 0.062).toFixed(2);
            totalPrice = ( parseFloat(subtotalProducts) + parseFloat(shippingPrice) + parseFloat(totalTax) ).toFixed(2);
            
            form.find('input[name=product_subtotal]').val(subtotalProducts);
            form.find('input[name=total_tax]').val(totalTax);
            form.find('input[name=total]').val(totalPrice);
            form.find('.total').find('span').text('$' + totalPrice);
        });
    
    
        $('form#registryPurchase').find('.ship-type').find('button').click(function (ev) {
            ev.preventDefault();
    
            var form = $(this).parents('form');
    
            var type = $(this).data('type');
    
            var shippingRate = 0;

            if( form.find('input[name=shipping_free]').val() == 'free-plm-shipping' ){
                shippingRate = 0;
            } else {
                if (type == 'ship-to-couple') {
                    shippingRate = 9.99;
                }
                else if (type == 'shipped' ){
                    shippingRate = 6.99;
                } else {
                    shippingRate = 0;
                }
            }
    
            form.find('input[name=shipping]').val(shippingRate);
            form.find('input[name=shipping_type]').val(type);
    
            form.find('.itemqty').change();

            var hasProduct = false;

            $('select.itemqty').each(function(){
                
                if( $(this).val() ){
                    hasProduct = true;
                }
            });
            
            if( !hasProduct ){
    
                $('.ship-fields').hide();
                $('.final-pay').hide();
                shippingPrice = '';
                form.find('input[name=shipping_type]').val('');
                form.find('input[name=shipping]').val(0);
                form.find('input[name=product_subtotal]').val(0);
                form.find('input[name=total_tax]').val(0);
                form.find('input[name=total]').val(0);
                form.find('.total').find('span').text('$0.00');
    
                alert("Please select at least one item to purchase from the registry list.");
                exit;
            }
    
            $('.ship-fields:not(.' + type + ')').fadeOut(200, function () {
                $('.ship-fields.' + type).fadeIn(200);
            });
    
            form.find('.final-pay').fadeIn(200);
        });
    
    
        $('form#registryPurchase').submit(function (ev) {
            ev.preventDefault();
    
            var form = $(this);

            var registryID = $(this).find('input[name=registry_id]').val();
            var registryPost = $(this).find('input[name=registrypost]').val();
    
            var total = $(this).find('input[name=total]').val();
            var shippingType = $(this).find('input[name=shipping_type]').val();

            if (!total) {
                return alert("Please select a product from the registry list.");
            }
    
            if (!shippingType) {
                return alert("Please select wether you wish to pick up in store or ship.");
            }
    
            if (shippingType == 'shipped') {
                var failed = false;
                var required = ['shipping_first_name', 'shipping_last_name', 'shipping_phone', 'shipping_address', 'shipping_city', 'shipping_state', 'shipping_zip'];
    
                $.each(required, function (key, val) {
                    var val = form.find('[name=' + val + ']').val();
                    if (!val || val.length < 1) {
                        failed = true;
                    }
                });
    
                if (failed) {
                    return alert("Please fill in all shipping recipient fields.");
                }

            } else if (shippingType == 'ship-to-couple') {
                var failed = false;
                var required = ['ship_to_couple_name','ship_to_couple_phone','ship_to_couple_message'];

                $.each(required, function (key, val) {
                    var val = form.find('[name=' + val + ']').val();
                    if (!val || val.length < 1) {
                        failed = true;
                    }
                });
    
                if (failed) {
                    return alert("Please fill in all ship to couple fields (even a short message).");
                }
                
            } else {
                var failed = false;
                var required = ['first_name', 'last_name', 'phone'];
    
                $.each(required, function (key, val) {
                    var val = form.find('[name=pick_up_' + val + ']').val();
                    if (!val || val.length < 1) {
                        failed = true;
                    }
                });
    
                if (failed) {
                    return alert("Please fill in all fields required for pickup.");
                }
            }
            
            var description = 'Order for Registry ID #' + registryID;
    
            var handler = StripeCheckout.configure({
                key: STRIPE_KEY,
                image: '/public/img/plums-logo.png',
                locale: 'auto',
                billingAddress: true,
                allowRememberMe: false,
                zipCode: true,
                token: function(token, args) {
                    var formData = form.serializeArray();
                    formData.push({
                        name: 'action',
                        value: 'buy_registry'
                    });
                    formData.push({
                        name: 'stripe_token',
                        value: token.id
                    });
                    formData.push({
                        name: 'email',
                        value: token.email
                    });
                    formData.push({
                        name: 'billing_name',
                        value: args.billing_name
                    });
    
                    $.post('/wp-admin/admin-ajax.php', formData).success(function (res) {
                        var receiptAmount = total * 100;

                        if (res.response_code) {
                            window.location.replace('/thank-you?id=' + registryPost + '&type=registry&amount=' + receiptAmount);
                        } else {
                            alert("We could not process your order. Please try again.");
                        }
                    }).error(function (res) {
                        if (res.responseJSON.message) {
                            alert(res.responseJSON.message);
                        }
                    });
                }
            });
    
            handler.open({
                name: "Plum's Cooking",
                description: description,
                amount: total * 100
            });
        });




/**
 * OTHER STUFF
 */

    function initializeMap() {
        var myLatLng = {lat: 43.548400, lng: -96.722000};

        var mapOptions = {
            center: new google.maps.LatLng(myLatLng),
            zoom: 16,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            panControl: false,
            zoomControl: false,
            mapTypeControl: false,
            scaleControl: false,
            streetViewControl: false,
            overviewMapControl: false,
            rotateControl: false,
            disableDefaultUI: true,
            scrollwheel: false,
            draggable: false
        };

        var map = new google.maps.Map(document.getElementById('google-map'),mapOptions);

        var marker = new google.maps.Marker({
            position: myLatLng,
            map: map,
            title: "Plum's Cooking",
            icon: '/public/img/design/map-marker.png',
            animation: google.maps.Animation.DROP
        });

    }

    function mobileMenu() {
        var menuButton = $('.mobile-nav-button'),
            menu = $('.mobile-nav-menu');

        menuButton.on('click', function(){
            menu.slideToggle();
        });

        $(window).resize(function(){
            if($(window).width() < 600) {
                menu.slideUp();
            }
        })
    }

    function courseControls() {
        var classTotal = 0;
        var giftCardBalance = 0;
        var giftCardUse = 0;

        window.inputNumber = function(el) {

            var min = el.attr('min') || false;
            var max = el.attr('max') || false;

            var els = {};

            els.dec = el.prev();
            els.inc = el.next();

            el.each(function() {
                init($(this));
            });

            function init(el) {

                function decrement() {
                    var value = el[0].value;
                    value--;
                    if(!min || value >= min) {
                        el[0].value = value;
                        updateRegistrationTotal(value);
                        $(el).trigger('change');
                    }
                }

                function increment() {
                    var value = el[0].value;
                    value++;
                    if(!max || value <= max) {
                        updateRegistrationTotal(value);
                        el[0].value = value++;
                        $(el).trigger('change');
                    }
                }

                els.dec.on('click', decrement);
                els.inc.on('click', increment);
            }
        };

        inputNumber($('.input-number'));

        function updateRegistrationTotal(value) {
            if($('.registration-controls').length > 0) {
                var cost = $('#course_cost').val();

                classTotal = Math.floor(((cost * value) * 1.062) * 100);

                $('.registration-controls .total span').html('$' + (classTotal / 100).toFixed(2));

                $('input[name=gift_card_use_balance]').keyup();
            }
        }

        $('.input-number').on('change', function(){
            updateRegistrationTotal($('.input-number').val());
        });

        $('#use-gift-card').click(function () {
            if ($('.gift-card-fields').hasClass('hidden')) {
                $('#pay-and-register').appendTo($('.gift-card-fields')).addClass('hidden');

                $('.gift-card-fields').removeClass('hidden');
                $(this).text('Cancel');
            } else {
                giftCardBalance = 0;
                $('input[name=gift_card_number], input[name=gift_card_verification_code], input[name=gift_card_use_balance]').val('');
                $('.input-number').change();

                $('.gift-card-fields').addClass('hidden');
                $('#pay-and-register').insertAfter($(this));
                $('.balances').addClass('hidden');
                $(this).text('Use Gift Card');
            }
        });

        $('input[name=gift_card_number], input[name=gift_card_verification_code]').change(function () {
            $(this).val(this.value.toUpperCase());
        });

        $('#check-balance').click(function () {
            $('.balances').addClass('hidden');

            giftCardBalance = 0;

            $.ajax({
                url: '/wp-admin/admin-ajax.php',
                data: {
                    action: 'check_gift_card_balance',
                    number: $('input[name=gift_card_number]').val(),
                    verification_code: $('input[name=gift_card_verification_code]').val()
                },
                type: 'post',
                error: function (jqXHR) {
                    if (jqXHR.responseJSON.message) {
                        alert(jqXHR.responseJSON.message);
                    }
                },
                success: function (data) {
                    giftCardBalance = data.balance_cents;
                    var balanceFixed = (giftCardBalance / 100).toFixed(2);

                    $('.balances').removeClass('hidden');
                    $('.balances').find('.balance').text('$' + balanceFixed);
                    $('.balances').find('input').val(balanceFixed).attr('max', balanceFixed);

                    $('.input-number').change();

                    $('#pay-and-register').removeClass('hidden');
                }
            })
        });

        $('input[name=gift_card_use_balance]').keyup(function () {
            var val = $(this).val().replace(/[^\d.-]/g, '');

            if (val.length < 1) {
                val = 0;
            }

            giftCardUse = Math.floor(parseFloat(val) * 100);
            if (giftCardUse > giftCardBalance) {
                $(this).val((giftCardBalance / 100).toFixed(2));
                giftCardUse = giftCardBalance;
            }

            if (giftCardUse > classTotal) {
                $(this).val((classTotal / 100).toFixed(2));
                giftCardUse = classTotal;
            }

            var owe = classTotal - giftCardUse;
            if (owe < 0) {
                owe = 0;
            }

            $('#total_amount').val(owe);
            $('.balances').find('.owe').text('$' + (owe / 100).toFixed(2));
        });

        $('.input-number').change();

        $('#pay-and-register').on('click', function(){

            var validForm = true;
            var formErrors = "";

            $('input.required').each(function(){

                if(!$(this).val()){
                    var myPlaceholder = $(this).attr('placeholder');
                    $(this).addClass('error');
                    formErrors = formErrors + myPlaceholder + ", ";
                    validForm = false;
                } else {
                    $(this).removeClass('error');
                }

            });

            if(!validForm){
                formErrors = formErrors.replace(/,\s*$/, "");
                alert("Please enter your " + formErrors);
            } else {
                var quantity = $('#quantity').val(),
                    classId = $('#class_id').val(),
                    firstName = $('#first_name').val(),
                    lastName = $('#last_name').val(),
                    emailAddress = $('#email_address').val(),
                    phoneNumber = $('#phone_number').val(),
                    participants = $('#participants').val(),
                    totalAmount = $('#total_amount').val(),
                    addedTotal = parseFloat(totalAmount),
                    description = $('#course_title').val(),
                    giftCardNumber = $('input[name=gift_card_number]').val(),
                    giftCardVerificationCode = $('input[name=gift_card_verification_code]').val(),
                    giftCardUseBalance = $('input[name=gift_card_use_balance]').val();

                if (giftCardUse == classTotal) {
                    $.post('/wp-admin/admin-ajax.php', {
                        quantity: quantity,
                        classId: classId,
                        firstName: firstName,
                        lastName: lastName,
                        emailAddress: emailAddress,
                        phoneNumber: phoneNumber,
                        participants: participants,
                        totalAmount: totalAmount,
                        description: description,
                        giftCardNumber: giftCardNumber,
                        giftCardVerificationCode: giftCardVerificationCode,
                        giftCardUseBalance: giftCardUseBalance,
                        action: 'register'
                    }).success(function (res){
                        window.location.replace('/thank-you?id=' + classId + '&type=register&amount=' + addedTotal );
                    }).error(function (res) {
                        if (res.responseJSON.message) {
                            alert(res.responseJSON.message);
                        }
                    });

                    return;
                }

                var handler = StripeCheckout.configure({
                    key: STRIPE_KEY,
                    image: '/public/img/plums-logo.png',
                    locale: 'auto',
                    billingAddress: true,
                    allowRememberMe: false,
                    zipCode: true,
                    token: function(token, args) {
                        $.post('/wp-admin/admin-ajax.php', {
                            stripeToken: token.id,
                            stripeEmail: token.email,
                            quantity: quantity,
                            classId: classId,
                            firstName: firstName,
                            lastName: lastName,
                            emailAddress: emailAddress,
                            phoneNumber: phoneNumber,
                            participants: participants,
                            totalAmount: totalAmount,
                            description: description,
                            args: args,
                            giftCardNumber: giftCardNumber,
                            giftCardVerificationCode: giftCardVerificationCode,
                            giftCardUseBalance: giftCardUseBalance,
                            action: 'register'
                        }).success(function (res){
                            window.location.replace('/thank-you?id=' + classId + '&type=register&amount=' + addedTotal );
                        }).error(function (res) {
                            if (res.responseJSON.message) {
                                alert(res.responseJSON.message);
                            }
                        });
                    }
                });

                handler.open({
                    name: "Plum's Cooking",
                    description: 'Class - ' + description,
                    amount: totalAmount
                });

            }

        });

        $('#promo-register').on('click', function(){

            var quantity = $('#quantity').val(),
                classId = $('#class_id').val(),
                firstName = $('#first_name').val(),
                lastName = $('#last_name').val(),
                emailAddress = $('#email_address').val(),
                phoneNumber = $('#phone_number').val(),
                participants = $('#participants').val(),
                description = $('#course_title').val();

            $.post('/wp-admin/admin-ajax.php', {
                quantity: quantity,
                classId: classId,
                firstName: firstName,
                lastName: lastName,
                emailAddress: emailAddress,
                phoneNumber: phoneNumber,
                participants: participants,
                description: description,
                action: 'promo_register'
            }).success(function(res){
                if(res == "success") { window.location.replace('/thank-you?id=' + classId + '&type=promo-register'); }
            });

        });

        $('#add-to-waitlist').on('click', function(){

            var validForm = true;
            var formErrors = "";

            $('input.required').each(function(){

                if(!$(this).val()){
                    var myPlaceholder = $(this).attr('placeholder');
                    $(this).addClass('error');
                    formErrors = formErrors + myPlaceholder + ", ";
                    validForm = false;
                } else {
                    $(this).removeClass('error');
                }

            });

            if(!validForm){
                formErrors = formErrors.replace(/,\s*$/, "");
                alert("Please enter your " + formErrors);
            } else {

                var quantity = $('#quantity').val(),
                    classId = $('#class_id').val(),
                    firstName = $('#first_name').val(),
                    lastName = $('#last_name').val(),
                    emailAddress = $('#email_address').val(),
                    phoneNumber = $('#phone_number').val();

                $.post('/wp-admin/admin-ajax.php', {
                    quantity: quantity,
                    classId: classId,
                    firstName: firstName,
                    lastName: lastName,
                    emailAddress: emailAddress,
                    phoneNumber: phoneNumber,
                    action: 'waitlist'
                }).success(function(res){
                    if(res == "success") {
                        window.location.replace('/thank-you?id=' + classId + '&type=wait-list&qty=' + quantity);
                    }
                });

            }

        });
    }

    function contactFormControls() {
        var form = $('#contact-form');

        form.validate({
            rules: {
                name: 'required',
                email: 'required',
                subject: 'required',
                message: 'required'
            },
            messages: {
                name: { required: "Please enter your name" },
                email: { required: "Please enter your email address" },
                subject: { required: "Please enter a subject for your message" },
                message: { required: "Please enter your message to us" }
            },
            errorPlacement: function(error, element) {
                error.insertAfter(element);
                return;
            },
            submitHandler: function(form) {
                var contactEmail = $('#contact_email').val(),
                    name = $('#name').val(),
                    email = $('#email').val(),
                    subject = $('#subject').val(),
                    message = $('#message').val();

                $.post('/wp-admin/admin-ajax.php', {
                    contact_email: contactEmail,
                    name: name,
                    email: email,
                    subject: subject,
                    message: message,
                    action: 'contact_submit'
                }).success(function(res){
                    window.location.replace('/thank-you?type=contact-form');
                });

                return;
            }
        });
    }

    function siteInitialize() {
        isotope();
        slick();
        mobileMenu();
        courseControls();
        contactFormControls();

        if ($('#google-map').length > 0) {
            google.maps.event.addDomListener(window, 'load', initializeMap);
        }
    }

    siteInitialize();
/*
    $('#email-signup-overlay').find('form').submit(function (ev) {
        ev.preventDefault();

        var overlay = $(this).parent();

        var email = $(this).find('input[name=email]').val();
        var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        if (!re.test(email)) {
            alert("Invalid email address.");
            return;
        }

        $.post('/wp-admin/admin-ajax.php', {
            email: email,
            action: 'newsletter_signup'
        }).success(function (res) {
            if (res.code == 200) {
                Cookies.set('hide_email_signup', true);

                overlay.fadeOut(200);
            }

            alert(res.message);
        });
    });
*/

    $('#email-signup-overlay').find('.close-trigger').click(function () {
        Cookies.set('hide_email_signup', true);
        $('#email-signup-overlay').fadeOut(200);
    });

    $('#email-signup-overlay').find('.close-trigger-link').click(function () {
        Cookies.set('hide_email_signup', true);
        $('#email-signup-overlay').fadeOut(200);
    });

    if (!Cookies.get('hide_email_signup')) {
        setTimeout(function () {
            $('#email-signup-overlay').fadeIn(200);
        }, 4000);
    }

    roundPrecision = function(number, precision) {
        var factor = Math.pow(10, precision);
        var tempNumber = number * factor;
        var roundedTempNumber = Math.round(tempNumber);
        return roundedTempNumber / factor;
    };

    $('.mobile-nav-menu li.has-children > a').click(function(){
        $(this).parent('li').toggleClass('open');
        return;
    });


    /* BLOG COMMENTS */
    $('span#commentCTA').click(function(){
        $('#respond .comment-reply-title').text('Write a Comment');
        $('#respond').appendTo( $(this).parents('.comment-cta-container') );
        $('#respond').addClass('visible');
        $('html, body').animate({
            scrollTop: $("#respond").offset().top - 50
        }, 800);

    });

    $('ol.commentlist span.reply-button').click(function(){
        
        $('#respond').removeClass('visible');
        $('form#commentform input#comment_parent').val('');

        var replyParent = $(this).data('comment');
        
        $('form#commentform input#comment_parent').val(replyParent);
        
        $('#respond').appendTo( $(this).parents('ol > li.depth-1') );
        $('#respond .comment-reply-title').text('Reply to Comment');
        $('#respond').addClass('visible');
        $('html, body').animate({
            scrollTop: $("#respond").offset().top - 50
        }, 800);

    });

    $('#recipeFilterTrigger').click(function(){
        $(this).parent('.recipe-filters').toggleClass('visible');
    });

    $('.recipe-filters .filter-menu li.has-children > a').click(function(){
        $(this).parent().toggleClass('expanded');
        return false;
    });

});

/*!
 * JavaScript Cookie v2.1.3
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
    var registeredInModuleLoader = false;
    if (typeof define === 'function' && define.amd) {
        define(factory);
        registeredInModuleLoader = true;
    }
    if (typeof exports === 'object') {
        module.exports = factory();
        registeredInModuleLoader = true;
    }
    if (!registeredInModuleLoader) {
        var OldCookies = window.Cookies;
        var api = window.Cookies = factory();
        api.noConflict = function () {
            window.Cookies = OldCookies;
            return api;
        };
    }
}(function () {
    function extend () {
        var i = 0;
        var result = {};
        for (; i < arguments.length; i++) {
            var attributes = arguments[ i ];
            for (var key in attributes) {
                result[key] = attributes[key];
            }
        }
        return result;
    }

    function init (converter) {
        function api (key, value, attributes) {
            var result;
            if (typeof document === 'undefined') {
                return;
            }

            // Write

            if (arguments.length > 1) {
                attributes = extend({
                    path: '/'
                }, api.defaults, attributes);

                if (typeof attributes.expires === 'number') {
                    var expires = new Date();
                    expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e+5);
                    attributes.expires = expires;
                }

                try {
                    result = JSON.stringify(value);
                    if (/^[\{\[]/.test(result)) {
                        value = result;
                    }
                } catch (e) {}

                if (!converter.write) {
                    value = encodeURIComponent(String(value))
                        .replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
                } else {
                    value = converter.write(value, key);
                }

                key = encodeURIComponent(String(key));
                key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
                key = key.replace(/[\(\)]/g, escape);

                return (document.cookie = [
                    key, '=', value,
                    attributes.expires ? '; expires=' + attributes.expires.toUTCString() : '', // use expires attribute, max-age is not supported by IE
                    attributes.path ? '; path=' + attributes.path : '',
                    attributes.domain ? '; domain=' + attributes.domain : '',
                    attributes.secure ? '; secure' : ''
                ].join(''));
            }

            // Read

            if (!key) {
                result = {};
            }

            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all. Also prevents odd result when
            // calling "get()"
            var cookies = document.cookie ? document.cookie.split('; ') : [];
            var rdecode = /(%[0-9A-Z]{2})+/g;
            var i = 0;

            for (; i < cookies.length; i++) {
                var parts = cookies[i].split('=');
                var cookie = parts.slice(1).join('=');

                if (cookie.charAt(0) === '"') {
                    cookie = cookie.slice(1, -1);
                }

                try {
                    var name = parts[0].replace(rdecode, decodeURIComponent);
                    cookie = converter.read ?
                        converter.read(cookie, name) : converter(cookie, name) ||
                        cookie.replace(rdecode, decodeURIComponent);

                    if (this.json) {
                        try {
                            cookie = JSON.parse(cookie);
                        } catch (e) {}
                    }

                    if (key === name) {
                        result = cookie;
                        break;
                    }

                    if (!key) {
                        result[name] = cookie;
                    }
                } catch (e) {}
            }

            return result;
        }

        api.set = api;
        api.get = function (key) {
            return api.call(api, key);
        };
        api.getJSON = function () {
            return api.apply({
                json: true
            }, [].slice.call(arguments));
        };
        api.defaults = {};

        api.remove = function (key, attributes) {
            api(key, '', extend(attributes, {
                expires: -1
            }));
        };

        api.withConverter = init;

        return api;
    }

    return init(function () {});
}));
